import React, { useState } from "react";
import json from "../content.json";
import SEO from "../components/SEO";
import Content from "../components/content";

export default () => {

  const selected = 'bg-blue-lightest text-blue-dark border-0';
  const unselected = 'bg-transparent h-60 text-blue-lightest border-2 border-blue-lightest';
  const [content, ] = useState(json['english']);
  const [englishButton, ] = useState(selected);
  const [spanishButton, ] = useState(unselected);

  function download() {
    window.location.href = content.download[1];
  }

  return (
    <>
      <SEO />
      <Content content={content} download={download} englishButton={englishButton} spanishButton={spanishButton} />
    </>
  )
}
